import React, { Component } from 'react';
import { Grid, Typography, Button, CircularProgress } from '@material-ui/core';
import OrderFinalizedImg from '../../scss/img/order_finalized.png'
import { withRouter, RouteComponentProps } from 'react-router'
import { Delivery, MissingProduct } from '../../api/models/QuotedData';
import { LocalDeliveryTime } from '../../Common/LocalDeliveryTime'
import { LocationAddress } from '../../api/models/LocationAddress';

type Props = {
    resetOrder: () => void,
    quotedOrder: Delivery,
    deliveryAddress: LocationAddress,
    getDeliveryAddress: () => void,
    getDeliveryAddressBusy: boolean,
    missingProducts: MissingProduct[] | null
} & RouteComponentProps<any>

type State = {
}

class OrderFinished extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {
        if (this.props.getDeliveryAddressBusy === false && this.props.deliveryAddress === null) {
            this.props.getDeliveryAddress()
        }
    }

    componentWillUnmount() {
        this.props.resetOrder()
    }

    render() {
        return (
            <Grid container alignItems="center">
                <Grid item xs={12} sm={12}>
                    <Typography variant="h1">All done!</Typography>

                </Grid>
                <Grid item xs={12} sm={12} style={{ textAlign: 'center' }}>
                    <img alt="" src={OrderFinalizedImg} />
                </Grid>

                <Grid item xs={12} sm={12} style={{ padding: '0px 15px 0 15px' }}>
                    <div>
                        <div style={{ display: 'inline-block' }}><Typography variant="subtitle1">PAYMENT STATUS:</Typography></div>
                        <div style={{ display: 'inline-block', marginLeft: '5px' }}><Typography variant="h4" color="primary">SUCCESS</Typography></div>
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} style={{ padding: '0 15px 15px 15px' }}>
                    <div>
                        <div style={{ display: 'inline-block' }}><Typography variant="subtitle1">TOTAL AMOUNT:</Typography></div>
                        <div style={{ display: 'inline-block', marginLeft: '5px' }}><Typography variant="h4">{this.props.quotedOrder.currency}&nbsp;{this.props.quotedOrder.finalPrice}</Typography></div>
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} style={{ padding: '15px' }}>
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle1">DELIVERY TIME</Typography>
                            <Typography variant="body2">
                                {LocalDeliveryTime(this.props.quotedOrder.plannedDeliveryStart, this.props.quotedOrder.plannedDeliveryEnd)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle1">DELIVERY COMPANY</Typography>
                            <Typography variant="body2">{this.props.quotedOrder.supplier.name}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} style={{ padding: '15px' }}>
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle1">DELIVERY ADDRESS</Typography>
                            {this.props.getDeliveryAddressBusy ?
                                <CircularProgress size={20} />
                                :
                                <span>
                                    {this.props.deliveryAddress !== null &&
                                        <span>
                                            <Typography variant="body2">{this.props.deliveryAddress.streetNumber}&nbsp;{this.props.deliveryAddress.street}</Typography>
                                            <Typography variant="body2">{this.props.deliveryAddress.suburb},&nbsp;{this.props.deliveryAddress.stateCode}</Typography>
                                            <Typography variant="body2">{this.props.deliveryAddress.postalCode}</Typography>
                                        </span>
                                    }
                                </span>
                            }
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle1">CONTACT DETAILS</Typography>
                            <Typography variant="body2">{this.props.quotedOrder.supplier.email}</Typography>
                            <Typography variant="body2">{this.props.quotedOrder.supplier.phoneNumber}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={12} style={{ padding: '15px', textAlign: 'center' }}>
                    <Button style={{margin:'8px'}} color="primary" variant="outlined" onClick={(e) => this.props.history.push('/')}>Go back to Home page</Button>
                    {(this.props.missingProducts !== null && this.props.missingProducts.length > 0) &&
                        <Button style={{margin:'8px'}} color="secondary" variant="contained" onClick={(e) => this.props.history.push('/Search')}>Quote&nbsp;&nbsp;{this.props.missingProducts!.length}&nbsp;&nbsp;remaining product{this.props.missingProducts.length > 1 ? "s" : ""}</Button>
                    }
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(OrderFinished);